import { useContext, useState } from "react";
import Lottie from "lottie-react";
import { Button, IconButton, SwipeableDrawer, Typography } from "@mui/material";
import { Box } from "@mui/system";
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { Notification, NotificationType } from "./Notification";
import BroadcastNotification from "./BroadcastNotification";
import AppContext from "../../AppContext";
import allDone from "@arelia-assets/lottie-animations/all-done.json"
import { Roles } from "../../types";
import { useNotifications, useReadNotificationMutation } from "../../api/notifications";

interface Props {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
}

export default function Norifications({ open, onClose, onOpen }: Props) {
  const { account } = useContext(AppContext);
  const { data } = useNotifications();
  const [showNotifications, setShowNotifications] = useState(true);
  const [notificationToEdit, setNotificationToEdit] = useState<NotificationType | null>(null);
  const unreadNotifications = data?.filter((notification: NotificationType) => !notification.isRead);

  const markAsReadMutation = useReadNotificationMutation();

  const markAsRead = (id: string) => markAsReadMutation.mutate(id);
  const readAll = () => markAsReadMutation.mutate();
  const handleEdit = (notification: NotificationType) => {
    setNotificationToEdit(notification);
    setShowNotifications(false);
  }

  const toggleShowNotifications = () => {
    setShowNotifications(!showNotifications);
  }

  const handleCancelBroadcastNotification = () => {
    setShowNotifications(true);
    setNotificationToEdit(null);
  }

  const handleCloseNotifications = () => {
    setShowNotifications(true);

    onClose();
  }

  return (
    <SwipeableDrawer
      anchor={"right"}
      swipeAreaWidth={0}
      open={open}
      onClose={handleCloseNotifications}
      onOpen={onOpen}
    >
      <Box sx={{
        width: "450px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "30px" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <NotificationsNoneOutlinedIcon sx={{ marginRight: "15px" }} />
            <Typography variant="subtitle2">Notifications</Typography>
          </Box>
          <IconButton onClick={handleCloseNotifications}>
            <CloseIcon />
          </IconButton>
        </Box>

        {showNotifications &&
          <>
            {
              !unreadNotifications || unreadNotifications.length === 0
                ? <>
                  <Box width="100%" height="100px" display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                    <Lottie animationData={allDone} style={{ height: 100 }} loop={false} />
                  </Box>
                  <Typography variant="subtitle1" align="center">All the notifications have been read.</Typography>
                </>
                : <></>
            }

            <Box sx={{ overflowY: "auto", height: "100%", px: "30px" }}>
              {unreadNotifications && unreadNotifications.map((notification: NotificationType) => (
                <Notification
                  key={notification.id}
                  notification={notification}
                  markAsRead={markAsRead}
                  handleEdit={handleEdit}
                />
              ))}
            </Box>
          </>
        }

        {!showNotifications &&
          <Box sx={{ p: "0 30px 30px", height: "100%" }}>
            <BroadcastNotification
              handleCancel={handleCancelBroadcastNotification}
              notification={notificationToEdit}
            />
          </Box>
        }

        {showNotifications &&
          <Box display="flex" padding="30px">
            {(unreadNotifications && unreadNotifications.length > 0) &&
              <Button variant="transparent" onClick={() => readAll()}>
                Mark All as Read
              </Button>}

            {account?.role === Roles.Admin &&
              <Button
                variant="contained"
                onClick={toggleShowNotifications}
                sx={{
                  ml: "auto",
                  display: "block"
                }}>
                Broadcast News
              </Button>}
          </Box>
        }
      </Box>
    </SwipeableDrawer>
  )
}